import { useQuery, Action } from "react-fetching-library";

export function useApiQuery(action: Action, initFetch = true) {
  const queryResult = useQuery(action, initFetch);
  return queryResult;
}